<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png"><span>选择物资</span>
      </div>
      <div class="tab-wrapper">
        <div class="tab-head">
          <div :class="{active: curItem === 1}" @click="tab(1)"><img v-if="curItem == 1" src="../../../assets/images/material-scan-icon2.png"><img v-else src="../../../assets/images/material-scan-icon.png">扫条码</div>
          <div :class="{active: curItem === 2}" @click="tab(2)"><img v-if="curItem == 2" src="../../../assets/images/material-goods-icon2.png"><img v-else src="../../../assets/images/material-goods-icon.png">选商品</div>
          <div :class="{active: curItem === 3}" @click="tab(3)"><img v-if="curItem == 3" src="../../../assets/images/material-search-icon2.png"><img v-else src="../../../assets/images/material-search-icon.png">搜索</div>
        </div>
        <div class="tab-content">
          <div v-if="curItem == 1" class="scan">
            <div class="scan-content">
              <img src="../../../assets/images/scan.png" @click="scanCode">
            </div>
          </div>
          <div v-if="curItem == 2">
            <div class="tab-classify">
              <div class="classify-title" @click="classifyClick">{{category_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
            </div>
            <div class="tab-goodslist" v-for="(goods, goods_key) in goodsList" :key="goods_key">
              <img class="goodsimg" src="../../../assets/images/mine-information-bj.png">
              <div class="goodsdetail">
                <div class="title">{{goods.name}}</div>
                <div>{{goods.label}}</div>
                <div>单位：{{goods.unit}}</div>
                <div>当前库存：{{goods.stock}}</div>
              </div>
              <img v-if="goodscurrent !== goods_key" class="addimg" @click="addclick" src="../../../assets/images/material-goods-add.png">
              <div v-else class="goodsnumber">
                <img class="editimg" src="../../../assets/images/material-goods-edit.png">
                <div>数量：1</div>
              </div>
              <!-- 添加进货框 -->
              <div class="purchase-box" v-if="purchaseBox">
                <div class="purchase-content">
                  <div class="purchase-goods">
                    <img class="editimg" src="../../../assets/images/mine-information-bj.png">
                    <div class="goods-detail">
                      <div class="title">维达130抽面巾纸</div>
                      <div>69651351351</div>
                      <div>库存：0个</div>
                    </div>
                  </div>
                  <div class="purchase-number">进货数量：<input type="number" :value="num_value" @input="input" /></div>
                  <div class="purchase-button">
                    <button @click="cancel">取消</button>
                    <button @click="confirm">确定</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="curItem == 3">
            <div class="common searchbox-wrapper">
              <input type="text" placeholder="请输入物品名称/条码">
              <img class="searchbox-close" src="../../../assets/images/repairman-search-close.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <div class="goodsdetailed" @click="selectgoods">
        <div>商品种类：4种</div>
        <div>总件数：120</div>
        <img class="goodsdetailed-img" src="../../../assets/images/right_jt.png">
      </div>
      <button>保存</button>
    </div>
    <!-- 已选商品 -->
    <div class="select-mask" v-if="selectGoods">
      <div class="select-mask-inner" style="height: 100%;background-color: #f6f6f6;">
        <div class="">
          <div class="title-box">
            <img src="../../../assets/images/close.png" @click="selectgoodsclose"><span>已选物品</span>
          </div>
          <div class="select-goods">
            <div class="select-goods-item">
              <div class="item-info">物品/条码</div>
              <div class="item-number" style="padding-top: 0;">数量</div>
            </div>
            <div class="select-goods-item">
              <div class="item-info">
                <div>护手霜</div>
                <div>6934354488222556699</div>
              </div>
              <div class="item-number">
                <img class="delete" src="../../../assets/images/repair-del.png">
                <img class="jia" src="../../../assets/images/jian.png">
                <div class="num"><input type="text" value="10" /></div>
                <img class="jia" src="../../../assets/images/jia.png">
              </div>
            </div>
            <div class="select-goods-item">
              <div class="item-info">
                <div>护手霜</div>
                <div>6934354488222556699</div>
              </div>
              <div class="item-number">
                <img class="delete" src="../../../assets/images/repair-del.png">
                <img class="jia" src="../../../assets/images/jian.png">
                <div class="num"><input type="text" value="10" /></div>
                <img class="jia" src="../../../assets/images/jia.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择资产分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'WarehouseOutAdd',
  metaInfo: {
    title: '物资管理'
  },
  data () {
    return {
      curItem: 2,
      category_id: 0,
      category_name: '全部分类',
      classifyPopup: false, // 分类
      classifyData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      goodsList: [
        {
          name: '灭火器',
          label: '6945354315312',
          unit: '提',
          stock: '3'
        },
        {
          name: '灭火器',
          label: '6945354315312',
          unit: '提',
          stock: '3'
        },
        {
          name: '灭火器',
          label: '6945354315312',
          unit: '提',
          stock: '3'
        }
      ],
      num_value: 1,
      goodscurrent: -1,
      purchaseBox: false, // 选择商品框
      selectGoods: false
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.getCategoryTree()

    let url = window.location.href.split('#')[0]
    console.log(url)
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    // 切换
    tab (e) {
      this.curItem = e
      this.showClassify = false
    },
    // 添加商品
    addclick (index) {
      console.log(index)
      this.purchaseBox = true
    },
    // 取消
    cancel () {
      this.purchaseBox = false
    },
    // 确定
    confirm () {
      this.purchaseBox = false
    },
    // 扫码
    scanCode () {
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          var str = result.split(',')
          // console.log(str)
          setTimeout(() => {
            // alert(result)
            console.log(str[1])
          }, 1000)
        }
      })
    },
    input (event) {
      console.log(event.target.value)
      if (event.target.value === 0 || event.target.value === '') {}
    },
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = [{id: 0, label: '全部分类'}].concat(res.data.data)
        }
      })
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.classifyPopup = false
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.label
      this.clickBlank()
    },
    selectgoods () {
      this.selectGoods = true
    },
    selectgoodsclose () {
      this.selectGoods = false
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
}
.tab-wrapper {
  font-size: 15px;
  width: 100%;
  height: calc(100% - 50px);
}
.tab-wrapper .tab-head {
  display: flex;
  background-color: #ffffff;
}
.tab-wrapper .tab-head div {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  color: #2f2f2f;
}
.tab-wrapper .tab-head div img {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 1px 6px 0 0;
}
.tab-wrapper .tab-head .active {
  color: #d93d55;
  position: relative;
}
.tab-wrapper .tab-head .active::after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -27%;
  bottom: 0;
  width: 55%;
  height: 2px;
  background-color: #d93d55;
}
.tab-wrapper .tab-content {
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: auto;
}
.tab-wrapper .tab-goodslist {
  display: flex;
  background-color: #ffffff;
  padding: 12px;
}
.tab-wrapper .tab-goodslist .goodsimg {
  width: 75px;
  height: 75px;
}
.tab-wrapper .tab-goodslist .goodsdetail {
  flex: 1;
  padding: 0 12px;
}
.tab-wrapper .tab-goodslist .goodsdetail div {
  color: #989898;
  font-size: 13px;
}
.tab-wrapper .tab-goodslist .goodsdetail .title {
  font-size: 15px;
  color: #43464f;
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.tab-wrapper .tab-goodslist .addimg {
  width: 20px;
  height: 20px;
  margin-top: 27px;
}
.tab-wrapper .tab-goodslist .goodsnumber {
  font-size: 13px;
  color: #2f2f2f;
  text-align: right;
}
.tab-wrapper .tab-goodslist .goodsnumber .editimg {
  width: 20px;
  height: 20px;
  margin-top: 10px;
}
.tab-wrapper .tab-goodslist .goodsnumber div {
  margin-top: 24px;
}
.tab-classify {
  padding: 10px 15px;
  color: #8f8f8f;
  font-size: 14px;
}
.tab-classify .classify-title img {
  width: 10px;
  height: 10px;
  padding-left: 8px;
}
.searchbox-wrapper {
  display: flex;
  position: relative;
  margin-bottom: 0;
  padding-bottom: 0;
  padding-top: 10px;
  padding-bottom: 5px;
}
.searchbox-wrapper input {
  flex: 1;
  height: 30px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(../../../assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
  outline: none;
}
.searchbox-wrapper .searchbox-close {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 16px;
  right: 20px;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  display: flex;
  font-size: 14px;
}
.backdrop-bottom button {
  width: 100px;
  height: 50px;
  line-height: 49px;
  background-color: #ff7c12;
  border-radius: none;
  border: none;
  color: #ffffff;
  font-size: 15px;
}
.backdrop-bottom .goodsdetailed {
  flex: 1;
  padding: 6px 20px;
  position: relative;
}
.backdrop-bottom .goodsdetailed-img {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 12px;
  height: 12px;
}
.purchase-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  align-items: center;
  justify-content: center;
  display: flex;
}
.purchase-box .purchase-content {
  background-color: #ffffff;
  border-radius: 5px;
  width: 70%;
}
.purchase-box .purchase-content .purchase-goods {
  padding: 15px;
  display: flex;
  font-size: 14px;
  color: #8f8f8f;
}
.purchase-box .purchase-content .purchase-goods img {
  width: 60px;
  height: 60px;
}
.purchase-box .purchase-content .purchase-goods .goods-detail {
  flex: 1;
  padding-left: 10px;
}
.purchase-box .purchase-content .purchase-goods .goods-detail .title {
  font-size: 15px;
  color: #000000;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.purchase-box .purchase-content .purchase-number {
  font-size: 15px;
  padding: 0 15px 15px 15px;
}
.purchase-box .purchase-content .purchase-number input {
  border-radius: 15px;
  border: none;
  height: 28px;
  background-color: #f7f7f7;
  outline: none;
  padding: 0 15px;
  width: 80px;
}
.purchase-box .purchase-content .purchase-button {
  display: flex;
  font-size: 16px;
}
.purchase-box .purchase-content .purchase-button button {
  flex: 1;
  height: 40px;
  background-color: #f7f7f7;
  border: none;
}
.purchase-box .purchase-content .purchase-button button:last-child {
  background-color: #ff7c12;
  color: #ffffff;
}
.scan {
  width: 100%;
  height: 100%;
}
.scan .scan-content {
  width: 100%;
  height: 100%;
  text-align: center;
}
.scan .scan-content img {
  width: 100px;
  height: 100px;
  margin-top: 90px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
.select-goods .select-goods-item {
  display: flex;
  font-size: 15px;
  background-color: #ffffff;
  padding: 12px;
}
.select-goods .select-goods-item .item-info {
  flex: 1;
  padding-right: 6px;
}
.select-goods .select-goods-item .item-info div {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.select-goods .select-goods-item .item-info div:first-child {
  font-weight: bold;
}
.select-goods .select-goods-item .item-info div:last-child {
  font-size: 13px;
  margin-top: 5px;
}
.select-goods .select-goods-item .item-number {
  padding-top: 10px;
}
.select-goods .select-goods-item .item-number div {
  display: inline-block;
}
.select-goods .select-goods-item .item-number .delete {
  width: 20px;
  height: 20px;
  padding-right: 10px;
}
.select-goods .select-goods-item .item-number img {
  vertical-align: top;
}
.select-goods .select-goods-item .item-number .num input {
  width: 40px;
  font-size: 15px;
  text-align: center;
  outline: none;
  border: none;
  border-bottom: 1px solid #333;
}
.select-goods .select-goods-item .item-number .jia {
  width: 20px;
  height: 20px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/WarehouseOut/WarehouseOutAdd.vue